import React from 'react';
import PropTypes from 'prop-types';
import { RemoveButton } from './Buttons';
import Editor from './Editor';

const SpeakerDetail = ({
  fields,
  speaker,
  removeSpeaker,
  // resizeImage,
  updateSpeaker,
  isValidSpeakerValue
  // onDrop
}) => {
  return (
    <div>
      <div className="is-divider custom-divider" data-content="Speaker detail" />
      {fields.speakers.length > 1 && <RemoveButton id={speaker.id} removeSpeaker={removeSpeaker} />}
      <div className="form-group columns">
        <label
          className={`control column is-2 label req ${
            isValidSpeakerValue(speaker.id, 'speakerName') ? '' : ' has-error'
          }`}
          htmlFor="speakerName">
          {speaker.speakerName.label}
        </label>
        <div className="column fix-space-sm">
          <input
            className={`form-control input is-rounded ${
              isValidSpeakerValue(speaker.id, 'speakerName') ? '' : ' is-danger'
            }`}
            name="speakerName"
            onChange={e => updateSpeaker(speaker.id, e)}
            placeholder="Speaker's Name"
            type="text"
            value={speaker.speakerName.value}
          />
        </div>
        <label
          className={`control column is-2 label req ${
            isValidSpeakerValue(speaker.id, 'email') ? '' : ' has-error'
          }`}
          htmlFor="email">
          {speaker.email.label}
        </label>
        <div className="column">
          <input
            className={`form-control input is-rounded ${
              isValidSpeakerValue(speaker.id, 'email') ? '' : ' is-danger'
            }`}
            name="email"
            onChange={e => updateSpeaker(speaker.id, e)}
            placeholder="Email Address"
            type="email"
            value={speaker.email.value}
          />
        </div>
      </div>
      <div className="form-group columns">
        <label
          className={`control column is-2 label req ${
            isValidSpeakerValue(speaker.id, 'company') ? '' : ' has-error'
          }`}
          htmlFor="company">
          {speaker.company.label}
        </label>
        <div className="column fix-space-sm">
          <input
            className={`form-control input is-rounded ${
              isValidSpeakerValue(speaker.id, 'company') ? '' : ' is-danger'
            }`}
            name="company"
            onChange={e => updateSpeaker(speaker.id, e)}
            placeholder="Company"
            type="text"
            value={speaker.company.value}
          />
        </div>
        <label
          className={`control column is-2 label req ${
            isValidSpeakerValue(speaker.id, 'country') ? '' : ' has-error'
          }`}
          htmlFor="country">
          {speaker.country.label}
        </label>
        <div className="column">
          <input
            className={`form-control input is-rounded ${
              isValidSpeakerValue(speaker.id, 'country') ? '' : ' is-danger'
            }`}
            name="country"
            onChange={e => updateSpeaker(speaker.id, e)}
            placeholder="Country"
            type="text"
            value={speaker.country.value}
          />
        </div>
      </div>
      <div className="form-group columns ">
        <label
          className={`control column is-2 label req ${
            isValidSpeakerValue(speaker.id, 'speakerBio') ? '' : ' has-error'
          }`}
          htmlFor="speakerBio">
          {speaker.speakerBio.label}
        </label>
        <div className="column">
          <textarea
            className={`form-control textarea ${
              isValidSpeakerValue(speaker.id, 'speakerBio') ? '' : ' is-danger'
            }`}
            name="speakerBio"
            onChange={e => updateSpeaker(speaker.id, e)}
            placeholder="About Speaker"
            rows="2"
            type="text"
            value={speaker.speakerBio.value}
          />
        </div>
      </div>
      <div className="form-group columns ">
        <label
          className={`control column is-2 label req ${
            isValidSpeakerValue(speaker.id, 'photo') ? '' : ' has-error'
          }`}
          htmlFor="photo">
          {speaker.photo.label}
        </label>
        <div className="column">
          <Editor
            imageId={speaker.id}
            imageValue={speaker.photo}
            // onDrop={onDrop}
            // resizeImage={resizeImage}
            updateImageData={updateSpeaker}
          />
        </div>
      </div>
    </div>
  );
};

SpeakerDetail.propTypes = {
  fields: PropTypes.objectOf(PropTypes.any).isRequired,
  isValidSpeakerValue: PropTypes.func.isRequired,
  // onDrop: PropTypes.func.isRequired,
  removeSpeaker: PropTypes.func.isRequired,
  // resizeImage: PropTypes.func.isRequired,
  speaker: PropTypes.objectOf(PropTypes.any).isRequired,
  updateSpeaker: PropTypes.func.isRequired
};

export default SpeakerDetail;
